var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttraction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.675 20.5C13.0417 19.7917 13.3833 18.9667 13.7 18H13.3333V16.3333H14.1667C14.675 14.1667 15 11.4417 15 8H16.6667C16.6667 11.4417 17 14.1667 17.5 16.3333H18.3333V18H17.9667C18.2833 18.9667 18.625 19.7917 18.9917 20.5H20V22.1667L21.6667 24.6667H19.65C19.0083 23.2 17.5417 22.1667 15.8333 22.1667C14.125 22.1667 12.6583 23.2 12.0167 24.6667H10L11.6667 22.1667L11.6417 20.5H12.675ZM16.325 18H15.3417C15.0896 18.8553 14.7749 19.6909 14.4 20.5H17.2667C16.9333 19.775 16.6083 18.9417 16.325 18Z",
    fill: "url(#paint0_linear_3410_9306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9306",
    x1: 20.7204,
    y1: 8,
    x2: 11.2549,
    y2: 14.9536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttraction);
export default __webpack_public_path__ + "static/media/attraction.5edf457a.svg";
export { ForwardRef as ReactComponent };